<template>
  <div>
    <div class="testtable admin-board">
      <div v-if="fetching" class="paznja-spinner">
        <svg class="dot-spin" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
      </div>
      <table v-else class="responstable">
        <tr>
          <th>
            Osoba
            <div class="downarrow"></div>
          </th>
          <th data-th="Detalji osobe">
            <span>OIB</span>
            <div class="downarrow"></div>
          </th>
          <th>
            Uloga
            <div class="downarrow"></div>
          </th>
          <th>
            Aktivnost
            <div class="downarrow"></div>
          </th>
          <th>
            Posljednja prijava
            <div class="downarrow"></div>
          </th>
        </tr>

        <tr v-for="(pers, idx) in finalni_arr_prikaza" :key="idx">
          <td class="admin-table-cell">
            <router-link :to="'/osobe/law/' + pers.uid">{{ pers.prezime }} {{ pers.ime }}</router-link>
          </td>
          <td class="admin-table-cell">
            <span>{{ pers.oib }}</span>
          </td>
          <td class="role-dropdown">
            <div class="cases-pagination-right">
              <div class="broj-redova uloga-drop">
                <select id="search-group" :value="pers.role" @change="changeRole(pers, $event)">
                  <option v-for="(role, key) in all_roles" :key="key" :value="role.id">
                    {{ role.name }}
                  </option>
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11">
                  <g>
                    <g>
                      <path fill="#3326ae"
                        d="M.204 3.503a.754.754 0 0 0 .572.264c.18 0 .354-.065.506-.196l1.816-1.828L4.92 3.571c.142.142.33.22.53.22.202 0 .39-.078.533-.22a.76.76 0 0 0 0-1.065L3.632.14A.748.748 0 0 0 3.1-.077c-.2 0-.388.077-.53.22L.203 2.522a.754.754 0 0 0 0 .98z" />
                    </g>
                    <g>
                      <path fill="#3326ae"
                        d="M6.026 7.411a.758.758 0 0 0-1.083-.067L3.12 9.17 1.291 7.343a.75.75 0 0 0-.532-.22.75.75 0 0 0-.534.221.757.757 0 0 0 0 1.065l2.36 2.364a.752.752 0 0 0 .533.219c.201 0 .39-.078.534-.22l2.374-2.38a.752.752 0 0 0 0-.98z" />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </td>
          <td class="admin-table-cell">
            <span>{{ isActiveUser(pers.uid) }}</span>
          </td>
          <td class="admin-table-cell">
            <span>{{ getDate(pers.last_notified) }}</span>
          </td>
        </tr>
      </table>
       <!-- <table  class="responstable">
        <tr>
          <th>
            Radnja 
            <div class="downarrow"></div>
          </th>
          <th data-th="Detalji osobe">
            <span>Nositelj</span>
            <div class="downarrow"></div>
          </th>
          <th>
            Administrator
            <div class="downarrow"></div>
          </th>
          <th>
            Suradnik
            <div class="downarrow"></div>
          </th>
        </tr>

        <tr>
          <td class="admin-table-cell">
            <span>Dodavanje događaja u kalendar.</span>
          </td>
          <td class="admin-table-cell" >
           <div :class="['task-checkbox', 'popup-check', 'active',]" style="width:20px;">
                               <div class="check"></div> </div> 
          </td>
          <td class="admin-table-cell" >
           <div :class="['task-checkbox', 'popup-check', ]" style="width:20px;">
                               <div class="check"></div> </div> 
          </td>
          <td class="admin-table-cell" >
           <div :class="['task-checkbox', 'popup-check', 'active',]" style="width:20px;">
                               <div class="check"></div> </div> 
          </td>
        </tr>
      </table> -->
    </div>
      


    <div class="cases-pagination admin-panel-pagination">
      <div class="cases-pagination-left">
        <div class="pagin-wrapp page-nav" v-if="all_pages.length > 1">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="all_pages.length>1">
          <div :class="{ 'curr-page': curr_page == all_pages.length }"
            @click="setPage(all_pages.length)">
            {{ all_pages.length }}
          </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <!-- <img style="width:16rem;" src="../assets/img/paginacija2.svg"> -->
      </div>
      <div class="admin-izmjeni-button" v-if="has_changes" @click="applyChangedRoles()">
        <span class="changes-text">{{ save_changes_text }}</span>
        <svg class="changes-svg-save" xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15"
          fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.34118 2.19415C0.487647 0.943173 1.54867 0 2.8095 0H12.2983C12.4591 0 12.6145 0.0584645 12.7354 0.164484L15.1736 2.30312C15.7218 2.78392 16.0246 3.48537 15.9984 4.21361L15.6946 12.6607C15.6476 13.966 14.5747 15 13.2671 15H2.65873C1.4843 15 0.492793 14.1283 0.343656 12.9646C-0.0948898 9.54261 -0.113781 6.07999 0.287401 2.65348L0.34118 2.19415ZM2.8095 1.32353C2.22087 1.32353 1.72551 1.76386 1.65713 2.3479L1.60335 2.80723C1.21469 6.1268 1.23299 9.48134 1.65785 12.7965C1.72233 13.2996 2.15098 13.6765 2.65873 13.6765H3.22146V9.92647C3.22146 9.07368 3.91351 8.38235 4.76719 8.38235H10.9501C11.8038 8.38235 12.4959 9.07368 12.4959 9.92647V13.6765H13.2671C13.8615 13.6765 14.3492 13.2065 14.3705 12.6131L14.6744 4.16609C14.6863 3.83507 14.5486 3.51623 14.2995 3.29768L12.0542 1.32838V3.39704C12.0542 4.24983 11.3622 4.94115 10.5085 4.94115H5.20883C4.35515 4.94115 3.66309 4.24983 3.66309 3.39704V1.32353H2.8095ZM4.98801 1.32353V3.39704C4.98801 3.51886 5.08688 3.61763 5.20883 3.61763H10.5085C10.6305 3.61763 10.7293 3.51886 10.7293 3.39704V1.32353H4.98801ZM11.171 13.6765H4.54637V9.92647C4.54637 9.80464 4.64524 9.70588 4.76719 9.70588H10.9501C11.0721 9.70588 11.171 9.80464 11.171 9.92647V13.6765Z"
            fill="#2D22A4" />
        </svg>
        <svg class="changes-svg-saved" style="margin-top: 0.3rem;display: none;" xmlns="http://www.w3.org/2000/svg"
          width="15" height="10" viewBox="0 0 15 10" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14.7364 0.258435C15.0879 0.603016 15.0879 1.16169 14.7364 1.50627L6.3364 9.74157C5.98492 10.0861 5.41508 10.0861 5.0636 9.74157L0.263604 5.03568C-0.087868 4.6911 -0.087868 4.13243 0.263604 3.78785C0.615076 3.44327 1.18492 3.44327 1.5364 3.78785L5.7 7.86981L13.4636 0.258435C13.8151 -0.0861451 14.3849 -0.0861451 14.7364 0.258435Z"
            fill="#05CAB0" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import moment from "moment";
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";
import admin from "@/apiCallers/admin";
import CuFizicka from "@/components/personComponents/createUpdateSudionici/CUFizicka.vue";
import gsap from "gsap";

export default {
  components: { CuFizicka },
  data() {
    return {
      slovo_pretrazivanja: "",
      active_user_id_list: [],

      all_users: [],
      all_roles: [],

      changed_users: new Map(),
      has_changes: false,

      ukupna_lista: [],
      finalni_arr_prikaza: [],

      accessToken: "",
      all_osobe: [],
      fetching: true,
      slova: [],
      inputFizVis: false,
      all_pages: [],
      curr_page: 1,
      br_redova: 5,
      save_changes_text: 'Spremi izmjene',
      left_dots_visible: false,
      right_dots_visible: false,
    };
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);

    await admin.getUsers().then((resp) => {
      this.all_users = resp.data.all_users;
      this.all_roles = resp.data.all_roles;
      this.active_user_id_list = resp.data.active_users
      this.calculatePageNumber();
      this.paginirajOdabrane();
      this.fetching = false;
    });
  },
  computed: {
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return this.curr_page == this.all_pages[this.all_pages.length - 1];
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if(this.curr_page == this.all_pages.length)
        left_end = this.curr_page-1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.all_pages.length)
        return_pages.push(right_start);
      if(right_start < this.all_pages.length-1)
      this.right_dots_visible = true;
      return return_pages
    },
  },
  watch: {
    curr_page: function () {
      this.paginirajOdabrane();
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD.MM.yyyy.");
    },
    isActiveUser(user_id) {
      return this.active_user_id_list.includes(user_id + "") ? "Aktivan" : "Neaktivan";
    },
    changeRole(pers, event) {
      var old_role = pers.role;
      if (this.changed_users.get(pers.uid) != null) {
        old_role = this.changed_users.get(pers.uid).old_role;
      }
      var tmp_switch_user = {
        id: pers.uid,
        new_role: parseInt(event.target.value),
        old_role: old_role,
      };
      pers.role = event.target.value;

      // if(this.changed_users.filter(p=> p))
      if (old_role != tmp_switch_user.new_role) {
        this.changed_users.set(pers.uid, tmp_switch_user);
      } else {
        this.changed_users.delete(pers.uid);
      }
      if (this.changed_users.size > 0) {
        this.has_changes = true;
      } else {
        this.has_changes = false;
      }
    },
    async applyChangedRoles() {
      this.changed_users.forEach(async (p) => {
        const changed_val = await admin.changeUserRole(p.id, p.new_role, this.accessToken);
      })
      this.executeAnimation();
    },
    executeAnimation() {
      gsap.to('.admin-izmjeni-button', 0, { backgroundColor: '#fff' })
      var tl = gsap.timeline();
      tl.fromTo('.changes-text', 0.5, { x: 0, opacity: 1 }, { x: -10, opacity: 0 })
      setTimeout(() => {
        this.save_changes_text = 'Spremljeno';
        tl.fromTo('.changes-text', 0.5, { x: -10, opacity: 0 }, { x: 0, opacity: 1 });
        tl.to('.changes-svg-save', 0.5, { opacity: 0 }, "-=0.5");
        tl.to('.changes-svg-save', 0, { display: "none" });

        tl.to('.changes-svg-saved', 0, { display: "flex" });
        tl.to('.changes-svg-saved', 0.5, { opacity: 1 }, "-=0.5");
        setTimeout(() => {
          gsap.to('.admin-izmjeni-button', 0.3, { opacity: 0 })
          setTimeout(() => {
            tl.to('.changes-svg-saved', 0, { display: "none", opacity: 0 });
            tl.to('.changes-svg-save', 0, { opacity: 1, display: "flex" });
            this.save_changes_text = 'Spremi izmjene';
            this.changed_users.clear();
            this.has_changes = false;
            gsap.to('.admin-izmjeni-button', 0, { backgroundColor: '#E1E6FB' })
            gsap.to('.admin-izmjeni-button', 0.5, { opacity: 1 })
          }, 500);
        }, 2000);
      }, 500);
      setTimeout(()=>{
        location.reload()
      },2000)
    },
    setPage(pg) {
      this.curr_page = pg;
    },
    calculatePageNumber() {

      this.all_pages = [];
      var finalni_broj = this.all_users.length / this.br_redova;
      if (this.all_users.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages.push(i);
      }
      if (this.all_pages.length != 0) {
        this.curr_page = 1;
      }
    },
    paginirajOdabrane() {
      let start_idx = 0 + this.br_redova * (this.curr_page - 1);
      let end_idx = this.br_redova * this.curr_page;

      this.finalni_arr_prikaza = this.all_users.slice(start_idx, end_idx);
      console.log(this.finalni_arr_prikaza)
    },

    getPosljednjiPredmet(popis_pred) {
      if (popis_pred == undefined) {
        return "";
      }
      console.log(popis_pred);
      var lista_predmeta = popis_pred.split(",");
      if (lista_predmeta.length > 0) {
        return lista_predmeta[0];
      } else return popis_pred;
    },
    getPosljednjiLink(popis_link) {
      console.log(popis_link);
      if (popis_link == undefined) {
        return "";
      }
      var url_list = popis_link.split(",");
      if (url_list.length > 0) {
        return url_list[0];
      } else return popis_link;
    },
    switchDate(inData) {
      if (inData == "-" || inData == null) {
        return "-";
      } else {
        return moment(inData.toString()).format("l");
      }
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },
    tableAnim() {
      gsap.fromTo(
        ".responstable",
        0.4,
        { x: -10, opacity: 0 },
        { x: 0, opacity: 1 }
      );
    },
  },
  mounted() {
    // paginacija
    this.$store.state.paginacija.title = "Administratorska ploča";
    // body class
    document.body.classList.add("osobe-institucije");
  },
  destroyed() {
    document.body.classList.remove("osobe-institucije");
  },
};
</script>

<style>
</style>